import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core';
import { CitationResourceType, CitedSource } from '../../../enterprise-ai-agent-step/ai-agent-citation.component';
import { SensitiveMessageContentComponent } from '../sensitive-content/sensitive-message-content.component';
import { SensitiveDataSource, SensitiveDataType } from '../activity-message.types';
import { LucideAngularModule } from 'lucide-angular';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-activity-sources',
  templateUrl: './activity-sources.component.html',
  styleUrls: ['./activity-sources.component.scss'],
  standalone: true,
  imports: [CommonModule, SensitiveMessageContentComponent, LucideAngularModule, TooltipModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActivitySourcesComponent {
  id = input.required<string>();
  sources = input.required<CitedSource[]>();

  urlSourcesWithSensitiveData = computed(() =>
    this.sources()
      .filter((source) => source.resourceType === CitationResourceType.WEBSITE)
      .map((source) => ({
        ...source,
        sensitiveData: {
          type: SensitiveDataType.SOURCE,
          fileName: source.fileName,
          hasSensitiveData: false,
        } as SensitiveDataSource & { hasSensitiveData: boolean },
      }))
  );
  fileSourcesWithSensitiveData = computed(() =>
    this.sources()
      .filter((source) => source.resourceType === CitationResourceType.FILE)
      .map((source) => ({
        ...source,
        sensitiveData: {
          type: SensitiveDataType.SOURCE,
          fileName: source.fileName,
          hasSensitiveData: false,
        } as SensitiveDataSource & { hasSensitiveData: boolean },
      }))
  );

  expandSources = signal(false);
}
